import { useRegisterSW } from "virtual:pwa-register/react";
import Toast from "./Toast";

export default function PwaUpdateToast() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <Toast
      message="tozenAI updated"
      actionLabel="Reload"
      onAction={() => updateServiceWorker(true)}
      onClose={() => setNeedRefresh(false)}
    />
  );
}
